import { Autocomplete, Box, Container, Divider, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, TextField } from '@mui/material';
import React, { Component } from 'react';
import axios from "axios";
import Api from '../../customlib/Api';
import Global from '../../customlib/Global';
import moment from 'moment';
import DateRangePickerRich from '../../customlib/DateRangePickerRich';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Title } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, 
    CategoryScale,
    LinearScale,
    BarElement,
    Title);

class CsReport extends Component {
    state = { 
        startDate: moment().tz("asia/jakarta"),
        endDate: moment().tz("asia/jakarta"),
        csLeadsReport: [],
        csLeadsReporLoading: false,
        csComplaintCategoriesReport: [],
        csComplaintCategoriesLoading: false,
        csHelpCategoriesReport: [],
        csHelpCategoriesLoading: false,
        csSatisfactionReport: [],
        csSatisfactionLoading: false,
        csRevisionNotes: [],
        csRevisionNotesLoading: false,
        users: [],
        selectedUser: {id: 0, name: "ALL CS"},
        dataCsComplaintCategories: {
            labels: ['Konfirmasi Pesanan', 'Complaint'],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        dataCsResponTime: {
            indexAxis: "y",
            labels: ['Average', 'Fastest', 'Slowest'],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    // 'rgba(255, 99,/, 86, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        dataCsCustomerSatisfaction: {
            labels: ['Puas', 'Belum Puas'],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        dataCsHelpCategories: {
            labels: [
                'Foto hasil produk belum ada', 
                'Produk tidak sesuai dengan request', 
                'Produk rusak', 
                'Foto lokasi produk belum ada'],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        test: {
    "labels": [
        "Konfirmasi Pesanan",
        "Complaint"
    ],
    "datasets": [
        {
            "label": "",
            "data": [
                11,
                48,
                1
            ],
            "backgroundColor": [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)"
            ],
            "borderColor": [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)"
            ],
            "borderWidth": 1
        }
    ]
}
     } 

    loadCsLeadsReport = () => {
        this.setState({csLeadsReporLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csLeadsReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    if(data.success === true){
                        this.setState({csLeadsReporLoading: false, csLeadsReport: data.data});
                    }else{
                        this.setState({csLeadsReporLoading: false, csLeadsReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csLeadsReporLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsComplainCategoriesReport = () => {
        this.setState({csComplaintCategoriesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csComplaintCategoriesReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsComplaintCategories};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.complaintCategory);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;

                        this.setState({csComplaintCategoriesLoading: false, csComplaintCategoriesReport: data.data, dataCsComplaintCategories: chartData}, () => {
                            console.log("dataCsComplaintCategories", this.state.dataCsComplaintCategories);
                        });
                    }else{
                        this.setState({csComplaintCategoriesLoading: false, csComplaintCategoriesReport: [], dataCsComplaintCategories: chartData});
                    }
                })
                .catch((error) => {
                  this.setState({csComplaintCategoriesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsHelpCategoriesReport = () => {
        this.setState({csHelpCategoriesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csHelpCategoriesReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsHelpCategories};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.helpCategory);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;
                        this.setState({csHelpCategoriesLoading: false, csHelpCategoriesReport: data.data, dataCsHelpCategories: chartData});
                    }else{
                        this.setState({csHelpCategoriesLoading: false, csHelpCategoriesReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csHelpCategoriesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsSatisfactionReport = () => {
        this.setState({csSatisfactionLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csCustomerSatisfactionReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsCustomerSatisfaction};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.review);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;
                        this.setState({csSatisfactionLoading: false, csSatisfactionReport: data.data, dataCsCustomerSatisfaction: chartData});
                    }else{
                        this.setState({csSatisfactionLoading: false, csSatisfactionReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csSatisfactionLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsRevisionNotes = () => {
        this.setState({csRevisionNotesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csRevisionNotes(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    if(data.success === true){
                        this.setState({csRevisionNotesLoading: false, csRevisionNotes: data.data});
                    }else{
                        this.setState({csRevisionNotesLoading: false, csRevisionNotes: []});
                    }
                })
                .catch((error) => {
                  this.setState({csRevisionNotesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadUsersBySlugRoles = () => {
    
            const params = {
                slugRoles: ["customer-service", "cs-purchase", "purchasing", "cs-payment", "rangkaian-bunga"]
                // slugRole: "account-executive"
            };
    
            axios
            // .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeader())
            .post(Api.userBySlugRoles(), params, Api.getRequestHeader())
            .then((response) => {
                console.log("SALESTELEUSER : ", response.data.data);
                let usersData = [{id: 0, name: "All CS"}];

                response.data.data.forEach(item => {
                    usersData.push(item);
                });
                this.setState({users: usersData});
            })
            .catch((error) => {
                console.error("There was an error!", error);
            });
        };

    componentDidMount(){
        this.reloadAll();
    }

    reloadAll = () => {
        this.loadCsLeadsReport();
        this.loadCsComplainCategoriesReport();
        this.loadCsHelpCategoriesReport();
        this.loadCsSatisfactionReport();
        this.loadCsRevisionNotes();
        this.loadUsersBySlugRoles();
    }

    handleDateChanged = (dateRange) => {
        if(dateRange && dateRange[0] && dateRange[1]){
            this.setState({startDate: dateRange[0], endDate: dateRange[1]}, () => {
                this.reloadAll();
            })
        }
    }

    handleSelectionChanged = (selected) => {
        console.log(`SELECTED : ${selected}`);
        let findSelectedUser = this.state.users.find(item => item.name === selected);

        if(findSelectedUser){
            this.setState({selectedUser: findSelectedUser}, this.reloadAll);
        }
    }

    handleCbUserChanged = (event) => {
        console.log(`SELECTED : ${event.target.value}`);
        // let findSelectedUser = this.state.users.find(item => item.name === selected);

        // if(findSelectedUser){
            this.setState({selectedUser: event.target.value}, this.reloadAll);
        // }
    }

    render() { 
        return (
            <Box width={"90vw"}>
                <Grid container spacing={1}>
                    <Grid item xs={5}></Grid>
                    <Grid item xs={4} textAlign={"right"}>
                        {/* <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">CS Name</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={this.state.selectedUser}
                                label="Cs Name"
                                onChange={this.handleCbUserChanged}
                            >
                                {
                                    this.state.users.map((item, index) => <MenuItem value={item}>{item.name}</MenuItem>)
                                }
                            </Select>
                            </FormControl> */}
                        <Autocomplete
                            id="free-solo-2-demo"
                            disableClearable = {true}
                            freeSolo 
                            size='small'
                            options={this.state.users.map((option) => {
                                // console.log("LABEL : ", option);
                                // return String(`${option.name} (${option.email})`) ;
                                return String(`${option.name}`) ;
                            })}
                            sx={{mt: '5px'}}
                            onChange={(event, newValue) => {
                                // console.log("NEWVALUE : ", event);
                                this.handleSelectionChanged(newValue);
                            }}
                            // value={this.state.contactData.lavenderSalesName}
                            value={this.state.selectedUser?.name ?? ""}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Nama CS"
                                // margin="0"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                                size='small'
                            />
                            )}
                        />
                    </Grid>
                    <Grid item xs={1} textAlign={"left"}>
                        <Box sx={{mt: "10px"}}>Tanggal : </Box>
                    </Grid>
                    <Grid item xs={2}>
                        <Box sx={{mt: "5px"}}>
                            <DateRangePickerRich title={"Tanggal Transaksi"} startDate={this.state.startDate} endDate={this.state.endDate} onDateChanged={this.handleDateChanged} />
                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{mt: "10px", mb: "10px", color: "blue"}} />
                
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>Leads Distribution</strong>
                            {
                                this.state.csLeadsReporLoading ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                            }
                            <Grid container spacing={1}>
                                <Grid item xs={6} textAlign={"center"}><strong>Agent</strong></Grid>
                                <Grid item xs={6} textAlign={"center"} sx={{backgroundColor: "#dedecc50"}}><strong>Leads</strong></Grid>
                            </Grid>
                            <Divider />
                            {
                                this.state.csLeadsReport?.map(group => {
                                    return (
                                        <Box>
                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>{group.csName}</Grid>
                                                <Grid item xs={6} textAlign={"right"} sx={{backgroundColor: "#dedecc50"}}>{group.leads.length}</Grid>
                                            </Grid>
                                            <Divider />
                                        </Box>
                                        
                                    );
                                })
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={8}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>Revision Notes</strong>
                            {
                                this.state.csRevisionNotesLoading ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                            }
                            <Grid container spacing={1}>
                                <Grid item xs={3} textAlign={"center"}><strong>Order</strong></Grid>
                                <Grid item xs={9} textAlign={"center"} sx={{backgroundColor: "#dedecc50"}}><strong>Notes</strong></Grid>
                            </Grid>
                            <Divider />
                            {
                                this.state.csRevisionNotes?.map(group => {
                                    return (
                                        <Box>
                                            <Grid container spacing={1}>
                                                <Grid item xs={3}>{group.order_number}</Grid>
                                                <Grid item xs={9} sx={{backgroundColor: "#dedecc50"}}>{group.revision_image_log}</Grid>
                                            </Grid>
                                            <Divider />
                                        </Box>
                                        
                                    );
                                })
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>Kategori Bantuan</strong>
                            {
                                this.state.csComplaintCategoriesLoading ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                            }
                            <Grid container spacing={1}>
                                <Grid item xs={6} textAlign={"center"}><strong>Kategori Bantuan</strong></Grid>
                                <Grid item xs={6} textAlign={"center"} sx={{backgroundColor: "#dedecc50"}}><strong>Total</strong></Grid>
                            </Grid>
                            <Divider />
                            {
                                this.state.csComplaintCategoriesReport?.map(group => {
                                    return (
                                        <Box>
                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>{group.complaintCategory}</Grid>
                                                <Grid item xs={6} textAlign={"right"} sx={{backgroundColor: "#dedecc50"}}>{group.leads.length}</Grid>
                                            </Grid>
                                            <Divider />
                                        </Box>
                                        
                                    );
                                })
                            }

                            
                            <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                {
                                    this.state.csComplaintCategoriesLoading ? <></> : 
                                    <Pie data={this.state.dataCsComplaintCategories} />
                                }
                                {/* <Pie data={this.state.test} /> */}
                            </Box>
                        </Box>
                    </Grid>
                    {/* <Grid item xs={4}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>CS Respon Time Report</strong>
                            <Divider sx={{mt: "5px", mb: "10px"}} />
                            <Bar data={this.state.dataCsResponTime} />
                        </Box>
                    </Grid> */}
                    <Grid item xs={8}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>Customer Satisfaction Report</strong>
                            {
                                this.state.csSatisfactionLoading ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                            }
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6} textAlign={"center"}><strong>Review</strong></Grid>
                                        <Grid item xs={6} textAlign={"center"} sx={{backgroundColor: "#dedecc50"}}><strong>Total</strong></Grid>
                                    </Grid>
                                    <Divider />
                                    {
                                        this.state.csSatisfactionReport?.map(group => {
                                            return (
                                                <Box>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={6}>{group.review}</Grid>
                                                        <Grid item xs={6} textAlign={"right"} sx={{backgroundColor: "#dedecc50"}}>{group.leads.length}</Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Box>
                                                
                                            );
                                        })
                                    }
                                </Grid>
                                <Grid item xs={6}>
                                    <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                        {
                                            this.state.csSatisfactionLoading ? <></> : <Pie data={this.state.dataCsCustomerSatisfaction} />
                                        }
                                    </Box>
                                </Grid>
                            </Grid>
                            
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>Kategori Complaint</strong>
                            {
                                this.state.csHelpCategoriesLoading ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                            }
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6} textAlign={"center"}><strong>Kategori Complaint</strong></Grid>
                                        <Grid item xs={6} textAlign={"center"} sx={{backgroundColor: "#dedecc50"}}><strong>Total</strong></Grid>
                                    </Grid>
                                    <Divider />
                                    {
                                        this.state.csHelpCategoriesReport?.map(group => {
                                            return (
                                                <Box>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={6}>{group.helpCategory}</Grid>
                                                        <Grid item xs={6} textAlign={"right"} sx={{backgroundColor: "#dedecc50"}}>{group.leads.length}</Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Box>
                                                
                                            );
                                        })
                                    }
                                </Grid>
                                <Grid item xs={6}>
                                    <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                        {
                                            this.state.csHelpCategoriesLoading ? <></> : <Pie data={this.state.dataCsHelpCategories} />
                                        }
                                    </Box>
                                </Grid>
                            </Grid>
                            
                        </Box>
                    </Grid>

                </Grid>
            </Box>
        );
    }
}
 
export default CsReport;